//Ajax load more
$('.loadmore-event').click(function() {
  var uniqueId = $(this).data('unique-id')
  $(this).text('Loading...')
  var data = {
    action: 'loadmore_event',
    query: window['true_posts_' + uniqueId], //eslint-disable-line
    page: window['current_page_' + uniqueId], //eslint-disable-line
  }
  $.ajax({
    url: window['ajaxurl_' + uniqueId], //eslint-disable-line
    data: data,
    type: 'POST',
    success: function(data) {
      if (data) {
        $('.loadmore-event[data-unique-id="' + uniqueId + '"]')
          .text('Load more')
          .before(data)
        window['current_page_' + uniqueId]++ //eslint-disable-line
        if (
          window['current_page_' + uniqueId] == window['max_pages_' + uniqueId]
        )
          $('.loadmore-event[data-unique-id="' + uniqueId + '"]').remove() //eslint-disable-line
      } else {
        $('.loadmore-event[data-unique-id="' + uniqueId + '"]').remove()
      }
    },
  })
})

$('.loadmore-event-upcoming').click(function() {
  var uniqueId = $(this).data('unique-id')
  $(this).text('Loading...')
  var data = {
    action: 'loadmore_event_upcoming',
    query: window['true_posts_' + uniqueId], //eslint-disable-line
    page: window['current_page_' + uniqueId], //eslint-disable-line
  }
  $.ajax({
    url: window['ajaxurl_' + uniqueId], //eslint-disable-line
    data: data,
    type: 'POST',
    success: function(data) {
      if (data) {
        $('.loadmore-event-upcoming[data-unique-id="' + uniqueId + '"]')
          .text('Load more')
          .before(data)
        window['current_page_' + uniqueId]++ //eslint-disable-line
        if (
          window['current_page_' + uniqueId] == window['max_pages_' + uniqueId]
        )
          $(
            '.loadmore-event-upcoming[data-unique-id="' + uniqueId + '"]'
          ).remove() //eslint-disable-line
      } else {
        $(
          '.loadmore-event-upcoming[data-unique-id="' + uniqueId + '"]'
        ).remove()
      }
    },
  })
})
